import { useState } from "react";

export const FunctionalIndicatorComponent = ({
    indicatorType, algoIndex, setAlgoData, algoPart
}) => {
    const [value, setValue] = useState(14)
    return (
        <div className='flex w-full h-full flex-col absolute bg-white gap-[1px] pt-[1px]'>
            <div className='text-[10px] font-bold w-[30px] pl-0 flex flex-row  justify-around w-full'>
                {indicatorType}
                <select className='border border-solid border-[#ddd] rounded-[5px] w-[35px] text-[10px] font-semibold h-[20px] text-center appearance-none outline-none' onChange={(e) => {
                    const key = algoPart === 'left' ? 'leftLogicComponentStatus' : 'rightLogicComponentStatus'
                    setAlgoData(key, {
                        index: algoIndex,
                        status: e.target.value
                    })
                }}>
                    {/* <option value={'Open'}>Open</option> */}
                    <option value={'Close'}>Close</option>
                    {/* <option value={'High'}>High</option> */}
                    {/* <option value={'Low'}>Low</option> */}
                </select>
            </div>
            <div className='flex flex-row gap-[3px] justify-center'>
                <input value={value} className='border border-solid border-[#ddd] rounded-[5px] w-[25px] text-[10px] pl-[5px] h-[20px] font-semibold outline-none' onChange={(e) => {
                    setValue(e.target.value)
                    const key = algoPart === 'left' ? 'leftLogicComponentInput' : 'rightLogicComponentInput'
                    setAlgoData(key, {
                        index: algoIndex,
                        timeRange: e.target.value
                    })
                }}/>
                <select className='border border-solid border-[#ddd] rounded-[5px] w-[35px] text-[10px] font-semibold h-[20px] text-center appearance-none outline-none' onChange={(e) => {
                    const key = algoPart === 'left' ? 'leftLogicComponentInterval' : 'rightLogicComponentInterval'
                    setAlgoData(key, {
                        index: algoIndex,
                        interval: e.target.value
                    })
                }}>
                    <option value={'1m'}>1m</option>
                    <option value={'5m'}>5m</option>
                    <option value={'15m'}>15m</option>
                    <option value={'30m'}>30m</option>
                    <option value={'1h'}>1h</option>
                    <option value={'4h'}>4h</option>
                    <option value={'1d'} selected>1d</option>
                    <option value={'1w'}>1w</option>
                </select>
            </div>
        </div>
    );
}